<template>
  <SelectText
    v-if="component.componentType == 'select'"
    :component="component"
  ></SelectText>
  <TextValue
    v-else-if="component.componentType == 'text'"
    :component="component"
  ></TextValue>
  <TextArea
    v-else-if="component.componentType == 'textArea'"
    :component="component"
  ></TextArea>
  <Checkbox
    v-else-if="component.componentType == 'checkbox'"
    :component="component"
  ></Checkbox>
  <GroupCheckbox
    v-else-if="component.componentType == 'groupCheckbox'"
    :component="component"
  ></GroupCheckbox>
  <GroupField
    v-else-if="
      component.componentType == 'groupField' ||
      component.componentType == 'someCheckbox'
    "
    :component="component"
  ></GroupField>
  <GroupRadioButton
    v-else-if="component.componentType == 'groupRadioButton'"
    :component="component"
  ></GroupRadioButton>
  <ConfirmGroup
    v-else-if="component.componentType == 'confirmGroup'"
    :component="component"
  ></ConfirmGroup>
  <MultipleImageSelect
    v-else-if="component.componentType == 'multipleImageSelect'"
    :component="component"
  ></MultipleImageSelect>
  <MultiInsertForm
    v-else-if="component.componentType == 'multiInsertForm'"
    :component="component"
  ></MultiInsertForm>
  <SelectionButton
    v-else-if="
      component.componentType == 'selection' ||
      component.componentType == 'onlySelectionGroup'
    "
    :component="component"
  ></SelectionButton>
  <MultiSelectGroup
    v-else-if="component.componentType == 'multiSelectionGroup'"
    :component="component"
  >
  </MultiSelectGroup>
  <Signature
    v-else-if="component.componentType == 'btnAssinatura'"
    :component="component"
  ></Signature>
  <InputText
    v-else-if="component.componentType != ''"
    :component="component"
  ></InputText>
</template>
<script>
import InputText from './InputText.vue'
import SelectText from './SelectText.vue'
import TextValue from './TextValue.vue'
import GroupField from './GroupField.vue'
import GroupCheckbox from './GroupCheckbox.vue'
import GroupRadioButton from './GroupRadioButton.vue'
import ConfirmGroup from './ConfirmGroup.vue'
import Checkbox from './Checkbox.vue'
import TextArea from './TextArea.vue'
import MultipleImageSelect from './MultipleImageSelect.vue'
import MultiInsertForm from './MultiInsertForm.vue'
import Signature from './Signature.vue'
import SelectionButton from './SelectionButton.vue'
import MultiSelectGroup from './MultiSelectGroup.vue'

export default {
  name: 'RenderPreview',

  components: {
    InputText,
    SelectText,
    TextValue,
    GroupCheckbox,
    GroupRadioButton,
    ConfirmGroup,
    Checkbox,
    TextArea,
    GroupField,
    MultipleImageSelect,
    MultiInsertForm,
    Signature,
    SelectionButton,
    MultiSelectGroup,
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },
}
</script>
